import { render, staticRenderFns } from "./barChart.vue?vue&type=template&id=0ed38552&scoped=true"
import script from "./barChart.vue?vue&type=script&lang=js"
export * from "./barChart.vue?vue&type=script&lang=js"
import style0 from "./barChart.vue?vue&type=style&index=0&id=0ed38552&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed38552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed38552')) {
      api.createRecord('0ed38552', component.options)
    } else {
      api.reload('0ed38552', component.options)
    }
    module.hot.accept("./barChart.vue?vue&type=template&id=0ed38552&scoped=true", function () {
      api.rerender('0ed38552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parkCustomer/components/barChart.vue"
export default component.exports